import { FilterKeywords, FilterPattern, FiltersModel } from "../../../common";

export class ContainersFiltersModel extends FiltersModel {
  containerNumber: string;
  type: string;
  approved: string;
  open: string;
  shipped: string;
  startDate: Date;
  trackingNumber: string;
  containerDetail: string;
  streamName: string;

  constructor(state?: string) {
    super();

    this.setState(state);
  }

  setState(input: string): string {
    input = super.setState(input);

    if (!input) return;

    let mappings: FilterKeywords[] = [
      {
        keyword: "type",
        setter: (value) => (this.type = this.clean(value)),
      },
      {
        keyword: "approved",
        setter: (value) => (this.approved = this.yesOrNo(value)),
      },
      {
        keyword: "open",
        setter: (value) => (this.open = this.yesOrNo(value)),
      },
      {
        keyword: "shipped",
        setter: (value) => (this.shipped = this.yesOrNo(value)),
      },
      {
        keyword: "start-date",
        setter: (value) => (this.startDate = new Date(value)),
      },
      {
        keyword: "tracking-number",
        setter: (value) => (this.trackingNumber = value),
      },
      {
        keyword: "container-detail",
        setter: (value) => (this.containerDetail = value),
      },
      {
        keyword: "stream-name",
        setter: (value) => (this.streamName = value),
      },
      {
        keyword: "id",
        setter: (value) => (this.containerNumber = value),
      },
    ];

    mappings.forEach((mapping) => {
      input = this.testValues(input, mapping);
    });

    return null;
  }

  getState(): string {
    let filters: string[] = [],
      superState = super.getState();

    if (this.containerNumber) filters.push(this.encode(this.containerNumber));
    if (this.type) filters.push(`type-${this.encode(this.type)}`);
    if (this.approved) filters.push(`approved-${this.approved}`);
    if (this.open) filters.push(`open-${this.open}`);
    if (this.startDate) filters.push(`start-date-${this.startDate.toLocaleDateString()}`);
    if (this.trackingNumber) filters.push(`tracking-number-${this.encode(this.trackingNumber)}`);
    if (this.shipped) filters.push(`shipped-${this.encode(this.shipped)}`);
    if (this.containerDetail) filters.push(`container-detail-${this.encode(this.containerDetail)}`);
    if (this.streamName) filters.push(`stream-name-${this.encode(this.streamName)}`);
    if (superState) filters.push(superState);

    return filters.join(" ");
  }

  public serializeFrom(stateBug: {}): void {
    Object.keys(stateBug).forEach((key) => {
      let value = decodeURI(stateBug[key]).trim();
      switch (key) {
        case "id":
          this.containerNumber = value;
          break;
        case "type":
          this.type = value;
          break;
        case "approved":
          this.approved = value;
          break;
        case "open":
          this.open = value;
          break;
        case "shipped":
          this.shipped = value;
          break;
        case "startDate":
          this.startDate = new Date(value);
          break;
        case "trackingNumber":
          this.trackingNumber = value;
          break;
        case "streamName":
          this.streamName = value;
          break;
        case "containerDetail":
          this.containerDetail = value;
          break;
      }
    });
  }

  public serializeTo(stateBug: {}): void {
    if (this.containerNumber) stateBug["id"] = this.containerNumber.trim();
    if (this.type) stateBug["type"] = this.type.trim();
    if (this.approved == "yes" || this.approved == "no") stateBug["approved"] = this.approved;
    if (this.open == "yes" || this.open == "no") stateBug["approved"] = this.open;
    if (this.startDate) stateBug["startDate"] = this.startDate;
    if (this.trackingNumber) stateBug["trackingNumber"] = this.trackingNumber;
    if (this.shipped) stateBug["shipped"] = this.shipped;
    if (this.streamName) stateBug["streamName"] = this.streamName;
    if (this.containerDetail) stateBug["containerDetail"] = this.containerDetail;
  }
}
